import getParams from '@app/shared/utils/object/getParams';
import addAnalyticsTrackLinkToATag from '@app/shared/utils/analytics/addAnalyticsTrackLink';

export { getParams, addAnalyticsTrackLinkToATag };
